// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5d1e731","453":"e55a1f6b","732":"a4b4e086","977":"e5ac40b1"}[chunkId] + ".chunk.js";
};